import request from "@/util/http";
import qs from "qs"; // 获取我的填报列表

export function getTargetTaskPage(query) {
  return request({
    url: "/admin/targettask/my/page",
    method: "get",
    params: query
  });
} // 获取系统角色列表

export function getRoleList(query) {
  return request({
    url: "/admin/role/list",
    method: "get",
    params: query
  });
} // 获取分派用户选择列表

export function getMixQueryUserPage(query) {
  return request({
    url: "/admin/user/mix/page",
    method: "get",
    params: query
  });
} // 更改状态

export function updateTargetStatus(query) {
  return request({
    url: "/admin/targettask/status",
    method: "put",
    data: query
  });
} // 分派列表

export function getTargetTaskAllocatePage(query) {
  return request({
    url: "/admin/targettask/allocate/page",
    method: "get",
    params: query
  });
} // 保存填报

export function saveWrite(query) {
  return request({
    url: "/admin/targettask/write/" + query.taskId,
    method: "post",
    data: query
  });
} // {taskId}
// 删除分派列表项

export function removeAllocateTargetTaskById(query) {
  return request({
    url: "/admin/targettask/".concat(query),
    method: "delete"
  });
} // 批量删除分派列表项

export function removeAllocateTargetTaskByMuchId(query) {
  var data = {
    taskIds: query.data.join(","),
    certigier: query.certigier
  };
  return request({
    url: "/admin/targettask/",
    method: "delete",
    params: data
  });
} // 清空下级 /targettask/clear/substask/{parentTaskId}

export function clearAllocateTargetNextTaskById(query) {
  return request({
    url: "/admin/targettask/clear/substask/".concat(query),
    method: "delete"
  });
} // 获取分派表单项内容

export function selectTargetTaskVOById(query) {
  return request({
    url: "/admin/targettask/" + query,
    method: "get"
  });
} // 获取分派表单项内容

export function selectTargetTaskNewById(query) {
  return request({
    url: "/admin/targettask/metadata/" + query.data,
    method: "get"
  });
} // 获取分派的层面

export function getLayerNameByTaskId(query) {
  return request({
    url: "/admin/utils/getLayerNameByTaskId?taskId=" + query,
    method: "get"
  });
} // 新增分派项

export function saveAllocateTargetTask(query) {
  return request({
    url: "/admin/targettask",
    method: "post",
    data: query
  });
} // 更新分派项

export function updateAllocateTargetTask(query) {
  return request({
    url: "/admin/targettask",
    method: "put",
    data: query
  });
} // 诊改保存

export function saveDispose(query) {
  return request({
    url: "/admin/targettask/spiral",
    method: "put",
    data: query
  });
}
export function fetchTarget(query) {
  return request({
    url: "/admin/target/my/page",
    method: "get",
    params: query
  });
} //"指标列表"

export function putTarget(query) {
  return request({
    url: "/admin/target/status/",
    method: "put",
    data: query
  });
} //文件佐证材料

export function putTargetFile(query) {
  return request({
    url: "/admin/targettask/file/" + query.taskId + "?fileIds=" + query.fileIds,
    method: "put" // data: query.fileId

  });
} // /admin/targettask/file/11111?fileIds=1111
// 通过id获取基础数据

export function getBasicData(id) {
  return request({
    url: "/admin/metadata/" + id,
    method: "get"
  });
} // 获取填报里面佐证文件列表

export function getTargettaskFilePage(query) {
  return request({
    url: "/admin/targettask/file/page",
    // url: "/admin/nzMyPlanFile/list",
    method: "get",
    params: query
  });
} // 删除当前块下全部分派列表项

export function removeAllAllocateTask(query) {
  return request({
    url: "/admin/targettask/clear/substask/" + query,
    method: "delete" // params: data

  });
} // 分页查询任务分派轨迹

export function getAssignlocusTaskPage(query) {
  return request({
    url: "/admin/assignlocus/task/page",
    method: "get",
    params: query
  });
} // 更新部门任务的数据部门

export function updateTargetDataDept(query) {
  return request({
    url: "/admin/targettask/dataDept",
    method: "put",
    data: query
  });
} // 获取个人任务汇总数据

export function getTargetTaskMySummary(query) {
  return request({
    url: "/admin/targettask/my/summary",
    method: "get",
    params: query
  });
} // 获取专业分页

export function getMajors(query) {
  return request({
    url: "/admin/majors/page",
    method: "get",
    params: query
  });
} // 获取班级分页

export function getClasses(query) {
  return request({
    url: "/admin/classes/page",
    method: "get",
    params: query
  });
} // 获取学科分页

export function getSubject(query) {
  return request({
    url: "/admin/subject/page",
    method: "get",
    params: query
  });
}
export function uploadFile(name) {
  return request({
    url: "/admin/files/upload/targettask?originalFileName=".concat(name),
    method: "get"
  });
}
export function downFile(id) {
  return request({
    url: "/admin/files/download/targettask/".concat(id),
    method: "get"
  });
}
export function downFilePlan(id) {
  return request({
    url: "/admin/files/download/targettask/".concat(id),
    method: "get"
  });
}
export function delfileUrl(id) {
  return request({
    url: "/admin/targettask/file/" + id,
    method: "delete" // params: obj

  });
}
export function treeLeftList(obj) {
  return request({
    url: "/admin/dept/taskAssignDept",
    method: "get",
    params: obj
  });
}
export function treeRightList(obj) {
  return request({
    url: "/admin/dept/taskAssignDeptList",
    method: "get",
    params: obj
  });
}